import React from 'react';
import PrintableCuesheet from 'main/components/show/cuesheet.printable/cuesheet.jsx';

export default React.createClass({
  displayName: 'PrintableShow',

  render() {
    const isGuest = window.location.href.indexOf('guest') !== -1;

    const type = this.props.type || this.props.params.type;

    return (
      <div>
        <PrintableCuesheet
          classes="printable-cuesheet"
          guest={isGuest}
          type={type}
        />
      </div>
    );
  },
});
